import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import config from "../config";

const { api } = config;

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

/*
  Considerazioni:
    - utilizzando openAPI, si può generare un client per le chiamate API che ha la responsabilità di gestire le chiamate
    di impostare axios ad ogni
*/

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;

    switch (error.response.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401: {
        const originalRequest = error.config;

        if (originalRequest.url === "api/v1/auth/refresh") {
          localStorage.removeItem("authUser");
          window.location.href = "/login";
          return Promise.reject(error);
        }

        if (!originalRequest._retry) {
          originalRequest._retry = true;
          const authUser = sessionStorage.getItem("authUser") || "{}";
          const refreshToken = JSON.parse(authUser)?.refreshToken;

          try {
            const response = await axios.post(
              "api/v1/auth/refresh",
              {},
              {
                headers: {
                  Authorization: `Bearer ${refreshToken}`,
                },
              }
            );

            const result = response.data.data;
            originalRequest.headers.Authorization = `Bearer ${result.accessToken}`;
            sessionStorage.setItem("authUser", JSON.stringify(result));

            // Impostare responseType per assicurarsi che sia JSON
            originalRequest.responseType = "json";

            return axios(originalRequest).then((response) => {
              if (typeof response.data === "string") {
                try {
                  response.data = JSON.parse(response.data);
                  return Promise.resolve(response);
                  
                } catch (error) {
                  return Promise.reject(
                    "Error parsing JSON response: " + error
                  );
                }
              }
              //return Promise.reject( "Error Authorization ");
            });
          } catch (refreshError) {
            sessionStorage.removeItem("authUser");
            window.location.href = "/login";
            return Promise.reject(refreshError);
          }
        }else{
          return Promise.reject(message);
        }
        break;
      }
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        return Promise.reject(message);
        break;

      default:
        message = error.message || error;
        return Promise.reject(message);
    }

  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from the given URL
   */
  get = async (url: string, params?: any): Promise<AxiosResponse> => {
    let response: AxiosResponse;

    let paramKeys: string[] = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = await axios.get(`${url}?${queryString}`, params);
    } else {
      response = await axios.get(`${url}`, params);
    }
    return response.data ? response.data : response;
  };

  /**
   * Posts the given data to the URL
   */
  create = async (url: string, data: any): Promise<AxiosResponse> => {
    const response = await axios.post(url, data);
    return response.data ? response.data : response;
  };

  /**
   * Updates data
   */
  update = async (url: string, data: any): Promise<AxiosResponse> => {
    const response = await axios.put(url, data);
    return response.data ? response.data : response;
  };

  put = async (url: string, data: any): Promise<AxiosResponse> => {
    const response = await axios.put(url, data);

    return response.data ? response.data : response;
  };

  /**
   * Deletes data
   */
  delete = async (
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    const response = await axios.delete(url, { ...config });

    return response.data ? response.data : response;
  };
}

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
